module.exports = __webpack_public_path__ + "8d40017b7e9e2f4cff47725d13e8b1b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Logos/PPN_ASSETS/see_a_doctor.jpg
// module id = 1569
// module chunks = 0